<template>
    <div class="d-flex flex-column" style="height: 100%; overflow: hidden">
        <div
            class="d-flex flex-column pa-0 py-0 flex-grow-1 my-1 px-0 mt-0 mb-0 pt-0 containerFull"
            style="height: 100%; overflow: hidden"
            :class="{ paddingRight: true }"
        >
            <div
                class="d-flex flex-column flex-grow-1"
                style="width: 100%; padding: 20px; z-index: 0"
                v-if="!bookingSent"
            >
                <v-sheet
                    class="rounded-lg pa-4 pt-6 pb-3 softShadow agentBox"
                    style="position: relative; min-height: 80px"
                    v-if="searchString.length == 0 && activeCategory.length == 0"
                >
                    <div
                        v-if="!loaded"
                        style="
                            position: absolute;
                            margin-left: auto;
                            margin-right: auto;
                            left: 0;
                            right: 0;
                            text-align: center;
                        "
                    >
                        <v-progress-circular indeterminate :color="config.customer.primaryColor"></v-progress-circular>
                    </div>

                    <div class="container">
                        <div
                            class="child ma-1 pa-2"
                            v-for="(data, i) in categories"
                            :key="i"
                            @click="showCategory(data.cat_id, data.category)"
                            style="border-radius: 6px"
                        >
                            <v-btn :color="config.customer.primaryColor" elevation="0" fab>
                                <v-icon color="white">mdi-{{ data.icon }}</v-icon>
                            </v-btn>

                            <div
                                style="
                                    padding-top: 5px;
                                    cursor: pointer;
                                    width: 100%;
                                    display: block;
                                    font-size: 12px !important;
                                "
                            >
                                {{ data.category }}
                            </div>
                        </div>
                    </div>
                </v-sheet>

                <v-sheet
                    class="rounded-lg pa-4 pt-6 pb-3 softShadow agentBox showCategory"
                    style="position: relative; min-height: 80px"
                    v-if="activeCategory.length > 0"
                >
                    <div
                        class="d-flex flex-row justify-space-between align-center mb-5"
                        style="width: 100%; position: relative"
                        @click="activeCategory = []"
                    >
                        <v-icon style="cursor: pointer" size="24" color="black">keyboard_arrow_left</v-icon>
                        <h4 style="margin-left: auto; margin-right: auto; position: absolute; left: 0; right: 0">
                            {{ categoryName }}
                        </h4>
                        <div></div>
                    </div>
                    <div class="content-category">
                        <v-expansion-panels flat class="softShadow">
                            <v-expansion-panel
                                v-for="(data, i) in activeCategory"
                                :key="i"
                                style="border-bottom: 1px #eee solid"
                            >
                                <v-expansion-panel-header style="font-size: 12px">
                                    {{ data.question }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content class="text-left">
                                    <span v-dompurify-html="data.answer" style="font-size: 12px"></span>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </v-sheet>
            </div>
        </div>
    </div>

    <!--
    <div style="">
        <div v-if="searchString.length == 0 && activeCategory.length == 0" style="overflow-y: auto; width:100%;  display: block; padding-right:10px; padding-top:10px; padding-left:10px;">
        <div class="color" style="float:left;"  @click="goBackSpecial()">
            <i class="material-icons" style="font-size: 30px; cursor:pointer;">keyboard_arrow_left</i>
        </div>
        <div v-if="!loaded" style="margin-top:150px;">
            <v-progress-circular
            indeterminate
            :color="config.customer.primaryColor"

            ></v-progress-circular>
        </div>
            <div class="container" >
                <div class="child" v-for="(data,i) in categories" :key="i" @click="showCategory(data.cat_id,data.category)" >
                       <center> <div class="border">
                            <i class="material-icons" style="color:white;">{{ data.icon}}</i>
                        </div></center>
                    <div style="padding-top:5px; cursor:pointer; width:100%; display:block;" >

                        {{ data.category }}
                    </div>
                </div>
            </div>
        </div>

        <div class="show-category" v-if="activeCategory.length > 0">
            <div class="color" style="float:left; padding-right:10px; padding-top:-10px; padding-left:10px;"  @click="activeCategory = []">
                <i class="material-icons" style="font-size: 30px;  cursor:pointer;">keyboard_arrow_left</i>
            </div>
            <div class="content-category" >
                <h3 style="margin-top:15px; margin-right:42px;">{{ categoryName }}</h3><br>
                <v-expansion-panels>
                    <v-expansion-panel
                    v-for="(data,i) in activeCategory" :key="i"
                    >
                    <v-expansion-panel-header>
                        {{data.question}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="text-left">
                        <span v-dompurify-html="data.answer"></span>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>


            </div>
        </div>
    </div>
    -->
</template>

<script>
    import config from '../api/config';

    export default {
        data() {
            return {
                searchString: '',
                categories: [],
                activeCategory: [],
                q: [],
                a: [],
                categoryName: '',
                loaded: false,
                config
            };
        },
        mounted() {
            this.$store.dispatch('getCat').then((data) => {
                this.categories = data;
                this.loaded = true;
            });
        },
        methods: {
            goBackSpecial() {
                this.$store.dispatch('goBack');
            },
            showCategory(id, name) {
                this.categoryName = name;
                this.$store.dispatch('getCatFromName', id).then((data) => {
                    this.activeCategory = data;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    $primary: var(--primaryColor);
    .container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .child {
        flex: 45%;
        width: 80px;
        margin-bottom: 20px;

        justify-content: center;
        flex-grow: 0;
    }

    .child:hover {
        background-color: #eee !important;
    }

    .border {
        background-color: $primary;
        width: 50px;
        padding: 13px;
        height: 50px;
        border-radius: 50%;
        justify-content: center;
        -webkit-transition: -webkit-transform 0.8s ease-in-out;
        transition: transform 0.8s ease-in-out;
    }
    .border:hover {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
        cursor: pointer;
    }

    .softShadow {
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.02), 0 2px 2px rgba(0, 0, 0, 0.02), 0 4px 4px rgba(0, 0, 0, 0.02),
            0 8px 8px rgba(0, 0, 0, 0.02), 0 16px 16px rgba(0, 0, 0, 0.01), 0 24px 24px rgba(0, 0, 0, 0.01);
    }
</style>
